/* jshint esversion: 6 */
import React, { startTransition } from 'react';
import PropTypes from 'prop-types';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import InputModal from 'app/components/InputModal/InputModal.jsx';
import Content from 'app/components/common/Content.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from 'underscore';
import { Link, redirect } from 'react-router-dom';
import classnames from 'classnames';
import setInputDefaults from 'app/mixins/InputDefaultsModule.js';
import ChooseFeedType from 'app/components/CreateFeed/ChooseFeedType.jsx';
import CreateFeed from 'app/components/CreateFeed/CreateFeed.jsx';
import CreateSubtypePanel from 'app/components/EditorComponents/CreateSubtypePanel.jsx';
import CreateFeedConfigure, { configureSubtitle } from 'app/components/CreateFeed/CreateFeedConfigure.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import CreateFeedSocial from 'app/components/CreateFeed/CreateFeedSocial.jsx';
import CreateFeedHeader from 'app/components/Headers/CreateFeedHeader.jsx';
import NewRouteProgress from 'app/components/CreateFeed/NewRouteProgress.jsx';
import FeedEditorTabs from 'app/components/EditorComponents/FeedEditorTabs.jsx';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import InputFieldUpdateMixin from 'app/mixins/InputFieldUpdateMixin.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import Loading from 'app/components/common/Loading.jsx';
import { compose } from 'redux';
import FeedProvider from 'app/redux/Providers/FeedProvider.jsx';
import PostGroupProvider from 'app/redux/Providers/PostGroupProvider.jsx';
import Utilities from 'app/utility/Utilities.js';
import UserMessages from 'app/modules/UserMessageModule.js';
import TwitterInputConfigPanel from 'app/components/EditorComponents/TwitterInputConfigPanel.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { SOCIAL_CREATE, SOCIAL_UPDATE } from 'app/redux/constants.js';
import MinimalModal from 'app/components/Modals/MinimalModal.jsx';
import PostingGroups from 'app/components/PostingTool/Accessories/PostingGroups.jsx';
import ReviewPanel from 'app/components/EditorComponents/ReviewPanel.jsx';
import CaretBorder from 'app/components/EditorComponents/CaretBorder.jsx';
import FirstSuccessModal from 'app/components/Modals/FirstSuccessModal.jsx';
import makeToast from 'app/modules/makeToast.js';
import { AutomationShell } from '@/shadcn/components/NewAutomation/AutomationShell.tsx';
import { BuildingProgress } from '@/shadcn/components/NewAutomation/BuildingProgress.tsx';
import { PostPreviewStep } from '@/shadcn/components/NewAutomation/PostPreviewStep.tsx';
import { ReviewStep } from '@/shadcn/components/NewAutomation/ReviewStep.tsx';
import { assetBase } from '@/lib/asset-base.ts';
import {
	outputAccountFromSocial,
	outputAccountInactive
} from '@/lib/output-account.ts';
import {
	behaviorValue,
	choiceHelp,
	firstPullChoices,
	postWhenChoices,
	REVIEW_BEHAVIOR_PATHS
} from '@/lib/review-behavior.ts';
import {
	connectedSourceFromInput,
	fetchInputPreview,
	inputPreviewRequest,
	postPreviewFromPayload,
	POST_PREVIEW_NETWORKS
} from '@/lib/input-preview.ts';

class RouteNew extends React.Component {
	constructor(props) {
		super(props);

		let constants = props.app.config.constants;

		this.guidedInputs = [
			constants.INPUT_TYPE_TWITTER,
			constants.INPUT_SUBTYPE_EBAY,
			constants.INPUT_SUBTYPE_ETSY,
			constants.INPUT_SUBTYPE_VIMEO,
			constants.INPUT_SUBTYPE_SHOPIFY,
			constants.INPUT_SUBTYPE_SUBSTACK,
			constants.INPUT_SUBTYPE_PINTEREST,
			constants.INPUT_SUBTYPE_YOUTUBE
		];

		/*
			The sources connected over OAuth. They never reach the tiles or the feed
			search: createInput sends each one straight to its own settings panel, so
			new/configure IS their source step. Anything walking the flow backwards
			to step 1 has to land there instead of on new/inputs.
		*/
		this.oauthConfigInputs = [
			constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
			constants.INPUT_TYPE_FACEBOOK_PAGE,
			constants.INPUT_TYPE_TIKTOK,
			constants.INPUT_TYPE_YOUTUBE
		];

		this.state = {
			route: {
				name: 'My New Route',
				type: props.app.config.constants.R_DEFAULT,
				activeFlag: true,
				inputs: [],
				socials: [],
				options: {
					filters: {},
					tracking: '',
					shortenerId: ''
				}
			},
			routeCreateError: null,
			validationErrors: null,
			validatingFeed: false,
			socialButtonActive: false,
			editedInput: null,
			authState: '',
			searchErrors: null,
			newPath: '',
			creatingSocial: false,
			newSocial: null,
			externalFeedUrl: '',
			baseUrl: '/share/automate/',
			mainTweeter: 0,
			inputType: 0,
			crossPostType: 0,
			subtypeConfigured: null,
			searchQuery: '',
			isDuplicateSocial: false,
			showPostGroupModal: false,
			incomingSocialsChecked: false,
			isFromAutomationsPage: false,
			addBatchSocials: false,
			preBatchSocials: [],
			isCreatingRoute: false,
			isReauthorizing: false,
			actionId: 0,
			// The account whose reactivation this step is waiting on, so it can
			// be added to the automation once the save actually lands.
			pendingSelectId: 0,
			// The source the building/post-preview screens are describing. Held
			// separately from editedInput because the preview is fetched once, on
			// the way in, and must not re-fetch every time the input record changes.
			buildingInput: null,
			previewPayload: null,
			previewError: null,
			fetchingPreview: false,
			previewNetwork: null
		};

		this.transitionToSocialSelection = this.transitionToSocialSelection.bind(this);
		this.transitionToReview = this.transitionToReview.bind(this);
		this.transitionToBuilding = this.transitionToBuilding.bind(this);
		this.transitionToPostPreview = this.transitionToPostPreview.bind(this);
		this.fetchPostPreview = this.fetchPostPreview.bind(this);
		this.recordPreviewEvent = this.recordPreviewEvent.bind(this);
		this.validateInputConfiguration = this.validateInputConfiguration.bind(this);
		this.createInput = this.createInput.bind(this);
		this.feedRemoval = this.feedRemoval.bind(this);
		this.onSocialClick = this.onSocialClick.bind(this);
		this.onSubtypeClick = this.onSubtypeClick.bind(this);
		this.onConnectSocial = this.onConnectSocial.bind(this);
		this.onAdvancedFeedConfigure = this.onAdvancedFeedConfigure.bind(this);
		this.saveNewRoute = this.saveNewRoute.bind(this);
		this.filterSocialsByName = this.filterSocialsByName.bind(this);
		this.filterSocialsByType = this.filterSocialsByType.bind(this);
		this.updateRouteName = this.updateRouteName.bind(this);
		this.storeRouteState = this.storeRouteState.bind(this);
		this.removeInvalidFeeds = this.removeInvalidFeeds.bind(this);
		this.redirectOnInvalidState = this.redirectOnInvalidState.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.setMainTweeter = this.setMainTweeter.bind(this);
		this.resetTwitters = this.resetTwitters.bind(this);
		this.modalSave = this.modalSave.bind(this);
		this.selectInputType = this.selectInputType.bind(this);
		this.returnToTiles = this.returnToTiles.bind(this);
		this.setSearchQuery = this.setSearchQuery.bind(this);
		this.showPostGroupModal = this.showPostGroupModal.bind(this);
		this.setNewSocial = this.setNewSocial.bind(this);
		this.backButtonHandler = this.backButtonHandler.bind(this);
		this.saveProgress = this.saveProgress.bind(this);
		this.onSocialCreated = this.onSocialCreated.bind(this);
		this.onSocialUpdated = this.onSocialUpdated.bind(this);
		this.onReactivate = this.onReactivate.bind(this);
		this.beforeReconnect = this.beforeReconnect.bind(this);

		// Held rather than rebuilt: unregistering matches the object that registered.
		this.socialCallbacks = [
			{action: SOCIAL_CREATE, func: this.onSocialCreated},
			{action: SOCIAL_UPDATE, func: this.onSocialUpdated}
		];
		this.goToStep = this.goToStep.bind(this);
		this.onReviewChange = this.onReviewChange.bind(this);

	}

	static getDerivedStateFromProps(props, state) {
		let nextState = {},
			i = 0,
			errors = [],
			constants = props.app.config.constants;

		errors = props.getApiErrors(['FEED_SEARCH']);
		if (errors.length) {
			nextState.searchErrors = errors[0];
		} else if (state.searchErrors !== null) {
			nextState.searchErrors = null;
		}

		return Object.keys(nextState).length ? nextState : null;

	}

	componentDidMount() {
		let socials = null,
			route = this.state.route,
			socialButtonActive = this.state.socialButtonActive,
			externalFeedUrl = '',
			constants = this.props.app.config.constants,
			mainTweeter = this.state.mainTweeter,
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		this.socialCallbacks.map((callback) => { this.props.registerCallback(callback); });

		// do initial load of routes and socials
		this.props.getRoutes();
		this.props.getSocials();
		this.props.getSocialTypes();
		this.props.getSocialInputCreds();

		/*
		 * The destinations step narrows its grid by posting group, and nothing
		 * else in this flow fetches them. Loaded here with the rest of the
		 * bootstrap rather than on arrival at that step, because this component
		 * mounts once for the whole wizard — the step transitions are route
		 * changes it re-renders through, not remounts. ADVANCED reaches the
		 * groups through its own modal instead.
		 */
		if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
			this.props.getPostGroups();
		}

		// If there's data in newRouteState it means we're coming back from a social input
		// creation or a social output creation. Don't report a new automation start in those cases
		if (!this.props.getPersistedData("newRouteState")) {
			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'New Automation - Start',
					event_data: {
						onboarding: onboarding !== null
					}
				})
			}
		}

		this.props.restorePeristedData("newRouteState", (state) => {
			if (!this.props.router.location.pathname.match("new/outputs")) {
				state.subtypeConfigured = null;
				if (state.editedInput !== null && state.editedInput.inputValid !== undefined) {
					state.editedInput.inputValid = false;
				}
			}
			state.creatingSocial = false;
			this.setState(state, () => {
				this.redirectOnInvalidState();
				this.props.clearValidatedInputs();
				this.props.clearPersistedData('newRouteState');
			});
		}, this);


		if (this.props.router.query && this.props.router.query.url !== undefined) {
			externalFeedUrl = decodeURIComponent(this.props.router.query.url);
			this.setState({
				externalFeedUrl: externalFeedUrl
			});
		}

		if (this.props.router.query && this.props.router.query.automation !== undefined) {
			this.setState({
				isFromAutomationsPage: true
			});
		}

		// if (this.props.router.location.pathname.match('content')) {
		// 	this.setState({
		// 		baseUrl: '/content/feed/'
		// 	});
		// }


		if (onboarding === null || onboarding.start === undefined) {
			if (dataLayer && onboarding !== null) {
				dataLayer.push({
					'event': 'anchor-pageview',
					'virtualURL': '/vp/addFeed'
				},{
					'event': 'onboarding-start'
				});
			}

			if (onboarding !== null) {
				onboarding.start = true;
				window.localStorage.setItem('onboarding', JSON.stringify(onboarding));
			}
		}

		// clear out social filter on mount
		this.props.clearFilter('socials');

	}

	componentDidUpdate(prevProps, prevState) {
		let route = this.state.route,
			input = {},
			authState = this.state.authState,
			path = '',
			constants = this.props.app.config.constants,
			onboarding = null,
			checkState = this.checkState,
			socialButtonActive = this.state.socialButtonActive,
			errors = [],
			i = 0,
			validationErrors = this.state.validationErrors,
			validatingFeed = this.state.validatingFeed,
			searchErrors = this.state.searchErrors;

		this.redirectOnInvalidState();

		if (prevProps && prevProps.router && prevProps.router.location.pathname !== this.props.router.location.pathname) {
			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
				if (this.props.router.location.pathname.match("new/inputs")) {
					route.inputs = [];
					route.socials = [];
					this.setState({
						route,
						inputType: 0
					});
				}
			}
		}

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		// POST is there for the services that need it.
        // if not ignore it.
		if (this.props.app.configLoaded &&
			this.props.app.userLoaded &&
			this.props.app.userPermsLoaded &&
			this.props.app.firstLoad.SOCIAL_LIST) {
			if (this.props.authState.credID) {
				// reset authState in state now so other render ops
				// don't try to call again
				if (this.props.authState.credID.match(/^INPUT/) ||
					this.props.authState.credID.match(/^REAUTHINPUT/) ||
					this.props.authState.credID.match(/^REAUTHREUSE/)) {
					this.props.authReturnHandler.apply(this, [
						null,
						this.createInput]);
				} else if (this.props.authState.credID.match(/^REAUTH_/)) {
					if (!this.state.isReauthorizing) {
						let parts = this.props.authState.credID.split("_"),
							socialId = parseInt(parts[2]);
						this.setState({
							isReauthorizing: true,
							actionId: socialId
						}, () => {
							this.props.authReturnHandler.apply(this, [{
									path: this.state.baseUrl + 'new/outputs'
								},
								(social) => {
									this.props.resetAuthState();
									/*
									 * The id arrives as text: AuthModule builds this record
									 * from the authState string it split, and route.socials
									 * holds numbers everywhere else.
									 */
									let reconnectedId = parseInt(social.id, 10),
										nextRoute = Object.assign({}, this.state.route);

									if (nextRoute.socials.indexOf(reconnectedId) === -1) {
										nextRoute.socials.push(reconnectedId);
									}

									/*
									 * Cleared even when the account was already a
									 * destination: these gate the REAUTH branch above, so
									 * leaving them set ignores every later reconnect.
									 */
									this.setState({
										route: nextRoute,
										isReauthorizing: false,
										actionId: 0
									});
								}
							]);
						})
					}



				} else if (this.props.authState.credID.match(/^POST/)) {
					this.props.authReturnHandler.apply(this, [{
						path: this.state.baseUrl + 'new/outputs'
					},
					(social) => {
						this.props.resetAuthState();
						this.setState({
							newSocial: social
						});
					}]);
					if (dataLayer && this.props.automatedRoutes.length === 0) {
						dataLayer.push({
							'event': 'anchor-pageview',
							'virtualURL': '/vp/addSocial'
						});
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Social Auth Return',
							event_data: {
								onboarding: onboarding !== null,
								social: ConstantMixin.getPostServiceNameByCode(authState.split("_")[1])
							}
						})
					}
					this.setState({
						creatingSocial: true
					});
				}
			} else {
				// check existing selected socials for ones that haven't been reconnected successfully
				// i.e. user hit cancel
				let cleanSocials = [];
				if (this.state.route.socials.length) {
					for (let i = 0; i < this.state.route.socials.length; ++i) {
						let socialId = this.state.route.socials[i],
							social = this.props.socials.list.find(({id}) => socialId === id);

						if (social && social.sysActionFlag === 0) {
							cleanSocials.push(social.id);
						}
					}
					if (cleanSocials.length !== this.state.route.socials.length) {
						let nextRoute = Utilities.deepClone(this.state.route);
						nextRoute.socials = cleanSocials;
						this.setState({
							route: nextRoute
						});
					}
				}
			}
		}

		if (prevProps.app.loading.FEED_SEARCH === true && this.props.app.loading.FEED_SEARCH === false) {
			// the tile page passes the users search query to the CreateFeed component through RouteNew
			// in the searchQuery state var. When a feed search completes, it's safe to clear it.
			if (this.state.searchQuery !== '') {
				this.setState({
					searchQuery: ''
				});
			}
			if (this.props.feeds.searchResults.feeds.length && this.state.searchErrors !== null) {
				this.setState({
					searchErrors: null
				});
			}
		}

		if (prevProps.app.loading.FEED_VALIDATE === true && this.props.app.loading.FEED_VALIDATE === false) {
			errors = this.props.getApiErrors(['FEED_VALIDATE']);

			if (validatingFeed) {
				validatingFeed = false;
			}

			if (errors.length) {
				validationErrors = errors[0];

				/*
					The simple find step draws no list of picked feeds, so a refused
					pick is dropped rather than left in the route. That puts the step
					back where it was, where CreateFeed's error block says why, and
					keeps the next pick at route.inputs[0], which is the feed the
					building step and the create read.
				*/
				if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
					let refusedUrl = (errors[0].post && errors[0].post.url) ? errors[0].post.url : null;

					route.inputs = route.inputs.filter((feed) => {
						return feed.feedValid === true || (refusedUrl !== null && feed.url !== refusedUrl);
					});
				}
			} else {
				for (i = 0; i < route.inputs.length; ++i) {
					if (this.props.feeds.validated.length) {
						let validatedFeed = this.props.feeds.validated.find((feed) => route.inputs[i].url === feed.url);
						if (validatedFeed) {
							route.inputs[i].feedValid = true;
							route.inputs[i].inputId = validatedFeed.inputId;
							/*
								FeedAPI::validate_api computes this from the feed it just
								parsed, so it is the authoritative cadence even for a feed
								picked out of the suggested catalogue (whose own figure is
								a day old at most, but is a stored average rather than this
								feed's current rate). Absent when the validator had no
								content to parse; the chip then shows no cadence.
							*/
							route.inputs[i].inputVelocity = validatedFeed.inputVelocity;
							if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
								route.inputs[i].inputValid = true;
							}
							validationErrors = null;
						}
					}
				}
			}
			this.setState({
				route,
				validatingFeed,
				validationErrors,
				searchErrors
			}, () => {
				if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE && this.state.validationErrors === null) {
					// route.inputs[0] rather than editedInput: the loop above attached
					// the validated inputId there, and that id is what the preview needs.
					this.transitionToBuilding(this.state.route.inputs[0]);
				}
			});
		}

		if (prevProps.app.loading.INPUT_VALIDATE === true && this.props.app.loading.INPUT_VALIDATE === false) {
			let editedInput = this.state.editedInput,
				subtypeConfigured = this.state.subtypeConfigured;

			errors = this.props.getApiErrors(['INPUT_VALIDATE']);
			if (errors.length) {
				validationErrors = errors[0];
				//using this variade as a 3 state
				// null == go to configure page
				// false == on configure page safe to advance to social
				subtypeConfigured = (!subtypeConfigured) ? null : false;
			} else {
				if (this.props.automatedRoutes.validInputs.length && !_.isEmpty(editedInput)) {
					for (i = 0; i < this.props.automatedRoutes.validInputs.length; ++i) {
						if (this.props.automatedRoutes.validInputs[i].id == editedInput.id) {
							editedInput = _.clone(this.props.automatedRoutes.validInputs[i]);
							// clear validatedInputs so the twice-validated inputs can work
							this.props.clearValidatedInputs();
							if (editedInput.inputValid !== undefined && editedInput.inputValid === false) {
								editedInput.inputValid = true;
							}
							validationErrors = null;
						}
					}
					for (i = 0; i < route.inputs.length; ++i) {
						if (route.inputs[i].id == editedInput.id) {
							route.inputs[i] = editedInput;
						}
					}
				}
			}

			this.setState({
				route,
				editedInput,
				validationErrors,
				subtypeConfigured
			});

			if (validationErrors === null) {
				// editedInput, not state: setState above hasn't landed yet, and this is
				// the freshly validated copy carrying the ids the preview needs.
				let simple = this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE;

				if (simple) {
					this.transitionToBuilding(editedInput);
				} else if (subtypeConfigured === false) {
					this.transitionToSocialSelection();
				} else if (this.state.editedInput.type == constants.INPUT_TYPE_TWITTER) {
					this.transitionToSocialSelection();
				} else {
					this.props.router.navigate(`${this.state.baseUrl}new/inputs`);
				}
			}
		}

		// we just created a new route -- redirect
		if (prevProps.app.loading.ROUTE_CREATE === true && this.props.app.loading.ROUTE_CREATE === false) {
			/*
			 * A descriptor rather than a node: this state is persisted to
			 * localStorage across the social-connect redirect, and JSON drops a
			 * React element's $$typeof, leaving something React rejects as an
			 * invalid child. SocialSelection turns this into the copy.
			 */
			let routeCreateErrors = this.props.getApiErrors(['ROUTE_CREATE']),
				createError = {kind: 'default'},
				nextRoute = Utilities.deepClone(this.state.route);

			// roll up the window to show the error
			window.scrollTo(0, 0);

			if (routeCreateErrors.length) {
				// A failure the handler didn't write itself (a 500, a timeout) has no
				// errors object, or only a string, and gets the general message.
				let routeCreateError = routeCreateErrors[0].errors || {};

				if (routeCreateError.socials !== undefined) {
					let keys = Object.keys(routeCreateError.socials),
						errorId = keys[0];

					if (errorId) {
						let social = this.props.socials.list.find(({id}) => { return errorId == id; });
						if (social) {
							nextRoute.socials.splice(nextRoute.socials.indexOf(social.id), 1);
							if (nextRoute.socials.length) {
								socialButtonActive = true;
							}
							createError = {kind: 'loop', socialName: social.name};
						}
					}
				}

				this.setState({
					route: nextRoute,
					routeCreateError: createError,
					socialButtonActive,
					isCreatingRoute: false
				}, () => {
					// redirect user to output page for errors for the time being
					if (this.props.app.flags.routeViewType !== constants.ROUTE_VIEW_ADVANCED) {
						this.props.router.navigate("/share/automate/new/outputs");
					}
				});
				this.props.deleteApiError(['ROUTE_CREATE']);

			} else {
				// new routes are pushed onto the end of automatedRoutes.list
				let newRoute = this.props.automatedRoutes.list[this.props.automatedRoutes.list.length - 1];

				this.setState({
					isCreatingRoute: false
				});

				/*
					The one place the flow still branches on the record rather than
					reporting it: 'Onboarding - Complete' is what closes the onboarding
					funnel, and it means something 'Route Created' does not.
				*/
				if (this.props.recordEvent && onboarding !== null) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Onboarding - Complete',
						event_data: {
							onboarding: true,
							'method': 'Route Created'
						}
					});
				} else if (this.props.recordEvent && onboarding === null) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Route Created',
						event_data: {
							onboarding: false
						}
					});
				}

				if (onboarding !== null) {
					window.localStorage.removeItem('onboarding');
					// show a special modal if this is the first thing someone has done
					this.props.addModal(
						<FirstSuccessModal
							{...this.props}
							context="newroute"/>
					);
				} else {
					makeToast("", "info", {
						title: "Automation created",
						description: "Posting will start soon"
					});
					this.props.addMessage(UserMessages.generateMessage(UserMessages.route.created, 'ROUTE_CREATE'));
				}


				if (dataLayer) {
					dataLayer.push({
						'event': 'anchor-pageview',
						'virtualURL': '/vp/routeCreated'
					},
					{
						'event': 'onboarding-route-created'
					});
				}
				if (dataLayer && onboarding !== null) {
					dataLayer.push({
						event: 'first_post',
						method: 'feed'
					});
				}


				// reset social filter here
				this.props.clearFilter('socials');
				if (newRoute !== undefined && newRoute !== null && newRoute.id) {
					this.props.router.navigate('/share/automate/detail/' + newRoute.id);
				}

			}
		}

		errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
		if (errors.length) {
			/*
			 * Dismissing one of these prompts has to take the error with it. The
			 * gate below is `isDuplicateSocial === false`, and answering resets
			 * that — so an error left in the store is read again on the very next
			 * update and the prompt comes straight back, which reads as a dead
			 * close button rather than as a loop.
			 *
			 * Both types, not just SOCIAL_CREATE: an account is moved with an
			 * update as often as a create — reactivating one that another account
			 * already holds is an update — and clearing only the create left the
			 * update behind to re-raise this.
			 */
			const clearSocialErrors = () => {
				this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
			};

			if (this.props.isDuplicateSocial() && this.state.isDuplicateSocial === false) {
				this.setState({
					isDuplicateSocial: true
				}, () => {
					let social = Utilities.deepClone(this.state.newSocial);

					this.props.showDuplicateSocialModal(social, {
						confirm: () => {
							this.props.closeAllModals();
							this.setState({
								newSocial: null,
								isDuplicateSocial: false
							});
						},
						cancel: () => {
							clearSocialErrors();
							this.props.closeAllModals();
							this.setState({
								creatingSocial: false,
								newSocial: null,
								isDuplicateSocial: false
							});
						}
					});
				});
			} else if ((this.props.isBlacklisted() || this.props.isMovementRestricted()) && this.state.isDuplicateSocial === false) {
				const confirm = () => {
					this.setState({
						creatingSocial: false,
						newSocial: null,
						isDuplicateSocial: false
					});
					clearSocialErrors();
					this.props.closeAllModals();
				};

				if (this.props.isBlacklisted()) {
					this.props.showBlacklistModal({
						confirm: confirm
					});
				} else {
					this.props.showMovementRestrictedModal({
						confirm: confirm
					});
				}

				this.setState({
					isDuplicateSocial: true
				});
			}
		}

		// trying to catch onboarding and select all socials
		if (route.inputs.length &&
			this.props.socials.list.length <= 2 &&
			this.props.socials.list.length > 0 &&
			route.socials.length === 0 && !this.state.incomingSocialsChecked) {
			let twitterCount = 0;
			for (i = 0; i < this.props.socials.list.length; ++i) {
				if (this.props.socials.list[i].psID == constants.POST_SVC_TWITTER) {
					++twitterCount;
				}
			}
			if (twitterCount <= 1) {
				this.props.socials.list.map((social) => {
					if (social && social.id !== undefined) {
						//if ([constants.POST_SVC_TIKTOK, constants.POST_SVC_YOUTUBE].indexOf(social.psID) === -1) {
						// only auto select if the social isn't the input already
						if (_.findWhere(route.inputs, {externalID: social.externalID}) === undefined) {
							if (social.activeFlag === 1 && social.sysActionFlag === 0) {
								route.socials.push(social.id);
							}
						}
						//}
					}
				});
				socialButtonActive = true;
				this.setState({
					route,
					socialButtonActive,
					incomingSocialsChecked: true
				});
			}
		}

		if ((prevProps.socials.list.length < this.props.socials.list.length) && prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false) {
			this.setState({
				creatingSocial: false
			});
		}

		if (Object.keys(prevProps.socials.batchCreates).length > 0 && Object.keys(this.props.socials.batchCreates).length === 0) {
			this.setState({
				addBatchSocials: true,
				preBatchSocials: [...this.props.socials.list]
			});
		}

		if (prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false && this.state.addBatchSocials) {
			let toBeSelected = [],
				nextRoute = Utilities.deepClone(this.state.route);

			this.props.socials.list.map((newSocial) => {
				if (!this.state.preBatchSocials.find((social) => social.id === newSocial.id)) {
					toBeSelected.push(newSocial.id);
				}
			});

			if (toBeSelected.length) {
				toBeSelected.map((id) => {
					if (nextRoute.socials.indexOf(id) === -1) {
						nextRoute.socials.push(id);
					}
				})
			}
			this.setState({
				preBatchSocials: [],
				route: nextRoute,
				addBatchSocials: false
			});
		}

		// 09-24-2025 - commenting this out as part of the onboarding/feed creation
		// rework. not sure the reset is what we want with more back buttons sprinked througout
		// and having a feed/social/config flow causes bugs (social -> config resets selected socials)
		//
		// reset state on free-form navigation
		// if ((prevProps.router.location.pathname.match("new/configure") && this.props.router.location.pathname.match("new/inputs")) ||
		// 	(prevProps.router.location.pathname.match("new/outputs") && this.props.router.location.pathname.match("new/configure")) ||
		// 	(prevProps.router.location.pathname.match("new/outputs") && this.props.router.location.pathname.match("new/inputs"))) {
		// 	let editedInput = this.state.editedInput,
		// 		subtypeConfigured = this.state.subtypeConfigured;
		// 	if (this.state.subtypeConfigured !== null) {
		// 		if (this.props.router.location.pathname.match("new/configure")) {
		// 			subtypeConfigured = false;
		// 		} else {
		// 			subtypeConfigured = null;
		// 		}
		// 		editedInput.inputValid = false;
		// 		this.props.clearValidatedInputs();
		// 		this.setState({
		// 			editedInput,
		// 			subtypeConfigured,
		// 		});
		// 	}
		// 	// reset the routeCreateError and selected socials on navigation
		// 	let nextRoute = Utilities.deepClone(this.state.route);
		// 	nextRoute.socials = [];
		// 	this.setState({
		// 		routeCreateError: null,
		// 		route: nextRoute
		// 	});
		// }

	}

	componentWillUnmount() {

		// The post-preview fetch is not cancellable and can outlive the flow.
		this.unmounted = true;

		this.props.clearFilter('socials');

		this.props.resetAuthState();

		this.socialCallbacks.map((callback) => { this.props.unregisterCallback(callback); });

	}

	/*
	 * A social was connected while the automation was being built, so it joins
	 * the destinations — unless it is the source, which would be a posting loop.
	 *
	 * Which accounts arrived used to be reconstructed by diffing the id lists
	 * either side of the response; `detail.changed` says so directly. It can be
	 * empty, and that is not an error: connecting an account this publisher
	 * already had creates nothing, and the rest of the work still has to happen.
	 */
	onSocialCreated(detail) {
		let route = this.state.route,
			constants = this.props.app.config.constants,
			needsInputCreds = false,
			errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

		// the duplicate/blacklist/restricted branch in componentDidUpdate owns
		// the failed case, and drew its modal on the way past
		if (errors.length) {
			return;
		}

		detail.changed.map((social) => {
			if (_.findWhere(route.inputs, {externalID: social.externalID}) === undefined) {
				route.socials.push(social.id);
			}

			if ([constants.POST_SVC_INSTAGRAM_BUSINESS, constants.POST_SVC_FACEBOOK, constants.POST_SVC_TIKTOK].indexOf(social.psID) !== -1) {
				needsInputCreds = true;
			}
		});

		if (needsInputCreds) {
			this.props.getSocialInputCreds();
		}

		this.props.closeAllModals();
		this.props.getUserPerms();

		this.setState({
			route,
			socialButtonActive: true,
			creatingSocial: false
		});

	}

	/*
	 * Activating or deactivating an account changes what is left on the plan.
	 *
	 * It also finishes a reactivation started from the destinations step: the
	 * account was clicked to be posted to, and it only became selectable when
	 * the save came back, so it joins the automation now. onSocialClick rather
	 * than a push, so it arrives under the retweet and main-tweeter rules every
	 * other selection obeys.
	 */
	onSocialUpdated(detail) {
		let social = null;

		this.props.getUserPerms();

		if (!this.state.pendingSelectId) {
			return;
		}

		social = _.find(detail.changed, (candidate) => {
			return candidate.id === this.state.pendingSelectId;
		});

		if (social === undefined || parseInt(social.activeFlag, 10) === 0) {
			return;
		}

		this.setState({pendingSelectId: 0}, () => {
			if (this.state.route.socials.indexOf(social.id) === -1) {
				this.onSocialClick(null, social.id);
			}
		});

	}

	/* The user confirmed the reactivate prompt; onSocialUpdated spends this. */
	onReactivate(social) {
		this.setState({
			pendingSelectId: social.id
		});
	}

	/*
	 * A reconnect hands the browser to the provider, so the half-built automation
	 * goes to disk before it leaves — componentDidMount restores it, and the
	 * REAUTH branch above puts the reconnected account into the restored route.
	 *
	 * saveProgress is the same hop the connect path takes. It persists from a
	 * setState callback, which is why the redirect is handed to it rather than
	 * run after it: called the other way round, the navigation can win.
	 */
	beforeReconnect(social, reconnect) {
		this.saveProgress(reconnect);
	}

	redirectOnInvalidState() {

		let currentPath = this.props.router.location.pathname;

		// Be sure they haven't reached a step past the source with no inputs
		if (currentPath.match("new/configure") && this.state.route.inputs.length === 0 ||
			currentPath.match("new/building") && this.state.route.inputs.length === 0 ||
			currentPath.match("new/preview") && this.state.route.inputs.length === 0 ||
			currentPath.match("new/outputs") && this.state.route.inputs.length === 0 ||
			currentPath.match("new/review") && this.state.route.inputs.length === 0) {
			this.props.router.navigate(this.state.baseUrl + 'new/inputs');
		}

	}



	transitionToSocialSelection(e) {
		let onboarding = null;

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (e) {
			e.preventDefault();
		}

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'anchor-pageview',
				'virtualURL': '/vp/addSocial'
			},
			{
				'event': 'onboarding-start-social'
			});
		}

		// Once per onboarding, once per visit otherwise — see componentDidMount.
		if (onboarding === null || onboarding.startSocial === undefined) {
			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: 'Automation Building - Connect Social',
					event_data: {
						onboarding: onboarding !== null
					}
				});
			}

			if (onboarding !== null) {
				onboarding.startSocial = true;
				window.localStorage.setItem('onboarding', JSON.stringify(onboarding));
			}
		}

		this.props.router.navigate(`${this.state.baseUrl}new/outputs`);

	}

	/*
		Analytics for the two screens the redesign added — "building" and the post
		preview.

		Every one of them names the source, since a preview that can't be built —
		or a user who backs out of one — is a property of the input type rather
		than of the step. `onboarding` matches the rest of the flow's events, so
		the new screens can be filtered into the onboarding funnel alongside them.
	*/
	recordPreviewEvent(eventName, eventData) {
		let source = this.state.buildingInput || this.state.editedInput || {},
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		if (!this.props.recordEvent) {
			return;
		}

		this.props.recordEvent({
			pub_id: this.props.user.detail.id,
			event_name: eventName,
			event_data: Object.assign({
				onboarding: onboarding !== null,
				type: ConstantMixin.getInputServiceByCode(source.subtype || source.type)
			}, eventData)
		});

	}

	/*
		The interstitial between settling on a source and choosing destinations.

		It sits HERE rather than after review — where an earlier directive in this
		file expected it — because every row of the design's checklist describes
		inspecting the source ("Reading recent items", "Checking how often it
		updates", "Preparing your preview"), none of which is what happens once
		the route is being created. The rows are paced, not measured: see
		BuildingProgress.

		The post preview is fetched from here, behind the checklist, so the next
		screen usually has its content before the user reaches it.
	*/
	transitionToBuilding(input) {
		let previewInput = input || this.state.editedInput;

		this.setState({
			buildingInput: previewInput,
			previewPayload: null,
			previewError: null,
			fetchingPreview: true,
			previewNetwork: null
		}, () => {
			this.recordPreviewEvent('Automation Building - View');
			this.fetchPostPreview(previewInput);
			this.props.router.navigate(`${this.state.baseUrl}new/building`);
		});

	}

	transitionToPostPreview() {

		/*
			`preview` records what the user is about to be shown, which the view
			event can't be read without: the building screen advances on a timer
			rather than on the fetch, so the same step lands on a real item, on the
			sample card, or on an error depending only on how the source resolved.
		*/
		let preview = 'sample';

		if (this.state.previewError) {
			preview = 'error';
		} else if (this.state.fetchingPreview) {
			preview = 'loading';
		} else if (this.state.previewPayload) {
			preview = 'live';
		}

		this.recordPreviewEvent('Automation Post Preview - View', {
			preview: preview
		});

		// replace, not push: the building screen advances on its own, so leaving it
		// in history means browser-Back lands on a screen that immediately throws
		// the user forward again. Back from here reaches the source step instead.
		this.props.router.navigate(`${this.state.baseUrl}new/preview`, {replace: true});

	}

	/*
		A source the endpoint can't resolve is not an error: a subtype feed that
		hasn't been validated yet has no inputId to send. The step falls back to the
		sample card, which is what it shows a brand-new user anyway.
	*/
	fetchPostPreview(input) {
		let constants = this.props.app.config.constants;

		if (inputPreviewRequest(input, constants) === null) {
			this.setState({
				fetchingPreview: false
			});

			return;
		}

		fetchInputPreview(this.props.app.config.apiUrl, input, constants)
			.then((payload) => {
				if (this.unmounted) {
					return;
				}

				this.setState({
					previewPayload: payload,
					fetchingPreview: false
				});
			})
			.catch(() => {
				if (this.unmounted) {
					return;
				}

				this.setState({
					previewError: "We couldn't load a preview of this source.",
					fetchingPreview: false
				}, () => {
					this.recordPreviewEvent('Automation Post Preview - Load Error');
				});
			});

	}

	transitionToReview(e) {
		let onboarding = null;

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (e) {
			e.preventDefault();
		}

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'anchor-pageview',
				'virtualURL': '/vp/reviewAutomation'
			},
			{
				'event': 'onboarding-review'
			});
		}
		/*
			The `onboarding.startSocial !== undefined` test this used to carry is
			gone with the gating: it asked whether the user had reached the
			destinations step, which has no answer for a user without an onboarding
			record — and review is only reachable from that step's own Next button,
			so it never excluded anything anyway.
		*/
		if (this.props.recordEvent) {
			this.props.recordEvent({
				pub_id: this.props.user.detail.id,
				event_name: 'Automation Building - Review Automation',
				event_data: {
					onboarding: onboarding !== null
				}
			});
		}

		this.props.router.navigate(`${this.state.baseUrl}new/review`);

	}

	modalSave(input) {
		input.inputValid = false;

		this.setState({
			editedInput: input
		}, () => {
			this.props.validateInput(this.state.editedInput);
		});
	}

	validateInputConfiguration(e) {
		let onboarding = null,
			editedInput = this.state.editedInput;

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		this.props.deleteApiError(['INPUT_VALIDATE']);

		editedInput.inputValid = false;
		this.props.clearValidatedInputs();

		this.setState({
			editedInput
		});

		if (this.guidedInputs.indexOf(this.state.editedInput.type) !== -1 || this.guidedInputs.indexOf(this.state.editedInput.subtype) !== -1) {
			// we have a subtype or a type that gets the same flow
			let serviceName = ConstantMixin.getInputServiceByCode(this.state.inputType);

			if (this.state.subtypeConfigured === null) {
				this.setState({
					subtypeConfigured: false
				}, () => {
					if (dataLayer) {
						dataLayer.push({
							'event': 'setting-feed-url',
							'service': serviceName,
							'onboarding': (onboarding !== null) ? true : false
						});
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Setting Feed URL',
							event_data: {
								onboarding: (onboarding !== null) ? true : false,
								type: serviceName
							}
						})
					}
					this.props.validateInput(this.state.editedInput);
				});
			} else if (this.state.subtypeConfigured === false) {
				this.setState({
					subtypeConfigured: true,
				}, () => {
					if (dataLayer) {
						dataLayer.push({
							'event': 'set-feed-url',
							'service': serviceName,
							'onboarding': (onboarding !== null) ? true : false
						});
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Setting Feed URL',
							event_data: {
								onboarding: (onboarding !== null) ? true : false,
								type: serviceName
							}
						})
					}
					this.props.validateInput(this.state.editedInput);
				});
			}
		} else {
			this.props.validateInput(this.state.editedInput);
		}

	}

	createInput(input) {
		let route = this.state.route,
			constants = this.props.app.config.constants,
			validatingFeed = this.state.validatingFeed,
			authState = this.state.authState,
			inputType = this.state.inputType,
			path = '',
			advancedDestination = this.state.baseUrl + 'new/configure/input/setup',
			simpleDestination = this.state.baseUrl + 'new/configure',
			searchErrors = this.state.searchErrors;

		setInputDefaults.apply(this, [input, input.type, this.props.user.perms, constants.R_DEFAULT]);

		if (input.type == constants.INPUT_TYPE_FEED && input.subtype === undefined) {
			this.props.feedValidate(input.url);
			validatingFeed = true;
			simpleDestination = advancedDestination = this.state.baseUrl + 'new/inputs';
			this.props.deleteApiError(['FEED_SEARCH']);
			searchErrors = null;
		} else if (input.subtype == constants.INPUT_SUBTYPE_PINTEREST) {
			// no op --- for now
		} else if (input.type == constants.INPUT_TYPE_INSTAGRAM || input.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
			if (input.scID) {
				let creds = null;
				if (this.props.automatedRoutes.socialInputCreds[input.type] !== undefined) {
					creds = this.props.automatedRoutes.socialInputCreds[input.type].find((cred) => { return cred.scID === input.scID; });
					if (creds) {
						input.name = creds.scName;
						input.externalID = creds.externalID;
					}
				}
			} else {
            	input.name = input.username;
			}
        } else if (input.type == constants.INPUT_TYPE_TWITTER) {
            input.attrs.user_name = "@" + input.username;
            input.name = "@" + input.username + " Timeline";
			inputType = constants.INPUT_TYPE_TWITTER;
		} else if (input.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
			if (input.scID) {
				let creds = null;
				if (this.props.automatedRoutes.socialInputCreds[input.type] !== undefined) {
					creds = this.props.automatedRoutes.socialInputCreds[input.type].find((cred) => { return cred.scID === input.scID; });
					if (creds) {
						input.name = creds.scName + " Posts";
						input.externalID = creds.externalID;
					}
				}
			} else {
				input.name = input.username + " Posts";
			}
			inputType = constants.INPUT_TYPE_FACEBOOK_PAGE;
		} else if (input.type == constants.INPUT_TYPE_TIKTOK) {
			if (input.scID) {
				let creds = null;
				if (this.props.automatedRoutes.socialInputCreds[input.type] !== undefined) {
					creds = this.props.automatedRoutes.socialInputCreds[input.type].find((cred) => { return cred.scID === input.scID; });
					if (creds) {
						input.name = creds.scName;
						input.externalID = creds.externalID;
					}
				}
			} else {
            	input.name = input.username;
			}
			inputType = constants.INPUT_TYPE_TIKTOK;
        } else if (input.type == constants.INPUT_TYPE_YOUTUBE) {
			if (input.scID) {
				let creds = null;
				if (this.props.automatedRoutes.socialInputCreds[input.type] !== undefined) {
					creds = this.props.automatedRoutes.socialInputCreds[input.type].find((cred) => { return cred.scID === input.scID; });
					if (creds) {
						input.name = creds.scName;
						input.externalID = creds.externalID;
					}
				}
			} else {
            	input.name = input.username;
			}
			inputType = constants.INPUT_TYPE_YOUTUBE;
        }

		if (this.props.isFreeUser()) {
            input.postLimit = 10;
        }

		route.inputs.push(input);

		this.setState({
			route: route,
			editedInput: input,
			validatingFeed,
			inputType,
			searchErrors
		}, () => {
			if (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED) {
				path = advancedDestination;
			} else {
				path = simpleDestination;
			}

			// just change path if advanced
			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				this.props.router.navigate(path);
			} else if (this.guidedInputs.indexOf(input.type) !== -1) {
				this.props.router.navigate('/share/automate/new/inputs');
			} else if (this.guidedInputs.indexOf(input.type) === -1 && this.guidedInputs.indexOf(input.subtype) === -1) {
				this.props.router.navigate(path);
			}
		});

		// clean up the Auth State before doing any kind of transition (if applicable)
		this.props.resetAuthState();

	}

	feedRemoval(feedId, removeInvalid) {
		let updatedRoute = this.state.route,
			updatedInputs = [],
			i = 0;

		for (i = 0; i < updatedRoute.inputs.length; ++i) {
			if (feedId) {
				if (updatedRoute.inputs[i].id != feedId) {
					updatedInputs.push(updatedRoute.inputs[i]);
				}
			} else if (removeInvalid) {
				if (updatedRoute.inputs[i].valid) {
					updatedInputs.push(updatedRoute.inputs[i]);
				}
			}
		}

		updatedRoute.inputs = updatedInputs;

		//RouteStore.clearErrors('validate', 'input');

		this.setState({
			route: updatedRoute,
			validationErrors: null
		});
	}

	onSocialClick(event, id) {
		let state = this.state,
			socialId = 0,
			socialIndex = 0,
			onboarding = null,
			constants = this.props.app.config.constants,
			test = null,
			twitterCount = 0;

		if (event) {
			socialId = parseInt(event.currentTarget.dataset.id, 10);
		} else if (id) {
			socialId = id;
		}

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (state.route.socials.find((id) => { return id === socialId; }) === undefined) {
			let social = _.find(this.props.socials.list, function(social) {
				return socialId == social.id;
			});
			if (social && social.psID == constants.POST_SVC_TWITTER) {
				if (state.mainTweeter == 0) {
					state.mainTweeter = socialId;
				}
				for (let key in state.route.socials) {
					test = _.find(this.props.socials.list, function(social) {
						return state.route.socials[key] == social.id;
					});
					if (test !== undefined) {
						if (test.psID == constants.POST_SVC_TWITTER) {
							++twitterCount;
						}
					}
				}
				if ((twitterCount + 1) > constants.MAX_TWITTER_OUTPUTS) {
					makeToast("Maximum retweet profiles reached", "warning");
					return;
				}
			}

			if (socialId) {
				state.route.socials.push(parseInt(socialId, 10));
				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Automation Building - Social Selected',
						event_data: {
							onboarding: onboarding !== null
						}
					});
				}
			}
		} else {
			// if the event isn't passed in, this call is coming
			// from the posting groups modal, don't unselect any
			// previously selected socials
			if (event) {
				if (state.mainTweeter == socialId) {
					state.mainTweeter = 0;
				}
				state.route.socials = _.without(state.route.socials, socialId);
			}
		}

		if (state.route.socials.length >= 1) {
			state.socialButtonActive = true;
		} else {
			state.socialButtonActive = false;
		}

		this.setState(state);
	}

	onSubtypeClick(e, subtype) {
		let constants = this.props.app.config.constants,
			onboarding = null,
			serviceName = ConstantMixin.getInputServiceByCode(subtype);

		if (e) {
			e.preventDefault();
		}

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'onboarding-create-subtype',
				'service': serviceName
			});
		}

		if (this.props.recordEvent) {
			this.props.recordEvent({
				pub_id: this.props.user.detail.id,
				event_name: "Automation Building - Add Feed Subtype",
				event_data: {
					onboarding: onboarding !== null,
					service: serviceName
				}
			})
		}

		this.createInput({
			type: constants.INPUT_TYPE_FEED,
			subtype
		});

	}

	onConnectSocial(event) {

		let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		let modal = (
			<SocialModal
				{...this.props}
				activeRoute={this.state.route}
				context="new-route"
				router={this.props.router}
				recordPath={this.props.recordPath}
				onboarding={onboarding}
				setNewSocial={this.setNewSocial}
				selectedSocials={this.state.route.socials}
				clearFilterOnClose={true}
				// the dialog's account screen can start a reconnect too, and this
				// automation is just as unsaved from in there
				reconnectHandler={this.beforeReconnect}
				updateSelectedSocials={(updates) => {
					let nextRoute = Utilities.deepClone(this.state.route),
						nextSocials = [...nextRoute.socials];

					if (_.isArray(updates.add)) {
						updates.add.map((id) => {
							if (nextSocials.indexOf(id) === -1) {
								nextSocials.push(id);
							}
						});
					}
					if (_.isArray(updates.remove)) {
						updates.remove.map((id) => {
							if (nextSocials.indexOf(id) !== -1) {
								nextSocials.splice(nextSocials.indexOf(id), 1);
							}
						})
					}

					nextRoute.socials = nextSocials;

					this.setState({
						route: nextRoute
					});

				}} />
		);

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'onboarding-start-social'
			});
		}

		/*
		 * persistData rather than saveProgress: this opens a picker modal, it
		 * does not hand the browser to a provider, so the spinner saveProgress
		 * raises would outlive a pick the user backs out of — closing the modal
		 * clears nothing, and the auth return sets the flag itself.
		 */
		this.props.persistData("newRouteState", this.state);

		this.props.addModal(modal);

	}

	onAdvancedFeedConfigure(e) {

		let input = {},
			i = 0,
			id = e.currentTarget.dataset.feedid,
			modal = null;

		for (i = 0; i < this.state.route.inputs.length; ++i) {
			if (this.state.route.inputs[i].id == id) {
				input = this.state.route.inputs[i];
				input.inputValid = false;
				break;
			}
		}

		this.setState({
			editedInput: input
		}, () => {
			this.props.router.navigate(this.state.baseUrl + 'new/configure/input');
		});

		this.props.clearValidatedInputs();

	}

	onModalClose(input) {
		let route = this.state.route,
			newInputs = [],
			i = 0,
			constants = this.props.app.config.constants;

		for (i = 0; i < route.inputs.length; ++i) {
			if ((_.isEqual(route.inputs[i], input) && route.inputs[i].valid === true) ||
			 	!_.isEqual(route.inputs[i], input)) {
				newInputs.push(route.inputs[i]);
			}
		}

		route.inputs = newInputs;

		this.setState({
			route: route
		}, () => {
			if (this.props.user.detail.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				this.props.validateInput(input);
			}
		});
		this.props.closeAllModals();
		this.props.router.navigate(this.state.baseUrl + 'new/inputs');

	}

	saveNewRoute() {
		let route = Utilities.deepClone(this.state.route),
			verifiedInputs = [],
			constants = this.props.app.config.constants;

		if (this.state.isCreatingRoute) {
			return;
		}

		// for simple routes set the route name to the name of the input feed
		// and catch any changes from the review stage before creating feed
		if (this.props.app.flags.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
			if (!_.isEqual(route.inputs[0], this.state.editedInput)) {
				route.inputs[0] = this.state.editedInput;
			}
			if (route.inputs && route.inputs[0] !== undefined) {
				route.name = route.inputs[0].name;
			}
			// hack the validated state since the only thing changeable on review is the name
			// and if it's too long the create method should catch it
			route.inputs[0].inputValid = true;
		}

		if (this.state.mainTweeter) {
			let twitterCount = 0;
			for (let i = 0; i < route.socials.length; ++i) {
				let social = _.find(this.props.socials.list, function(social) {
						return route.socials[i] == social.id;
					}.bind(this));
				if (social) {
					if (social.psID == constants.POST_SVC_TWITTER) {
						++twitterCount;
					}
				}
			}
			if (twitterCount > 1) {
				route.tweeter = this.state.mainTweeter;
			}
		}

		// double check there aren't any invalid feeds
		for (let i = 0; i < route.inputs.length; ++i) {
			if (route.inputs[i].inputValid === true) {
				verifiedInputs.push(route.inputs[i]);
			}
		}

		// double check just to be safe
		if (!verifiedInputs.length) {
			// TODO: throw an error
			return;
		}

		route.inputs = verifiedInputs;

		this.setState({
			socialButtonActive: false,
			routeCreateError: null,
			isCreatingRoute: true
		});

		this.props.createRoute(route);

		this.props.clearPersistedData('newRouteState');

	}

	filterSocialsByName(e, search) {
		this.props.filterStore('socials', ['name'], search);
	}

	filterSocialsByType(e, key) {
		let exact = false;
		if (key !== '') {
			exact = true;
		}
		this.props.filterStore('socials', ['psID'], key, exact);
	}

	updateRouteName(event) {
		let updatedRoute = this.state.route;

		updatedRoute.name = event.currentTarget.value;
		this.setState({
			route: updatedRoute
		});
	}

	storeRouteState(service) {
		let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		if (service) {
			let serviceName = ConstantMixin.getInputServiceByCode(service);
			if (dataLayer && onboarding !== null) {
				dataLayer.push({
					'event': 'onboarding-connect-social-feed',
				});
			}

			if (this.props.recordEvent) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: "Automation Building - Add Social Feed",
					event_data: {
						onboarding: onboarding !== null,
						social: serviceName
					}
				})
			}
		}
		this.saveProgress();
	}

	removeInvalidFeeds() {

		this.feedRemoval(0, true);

	}

	setMainTweeter(id) {
		let socials = this.state.route.socials,
			route = this.state.route;

		if (id !== undefined) {
			id = parseInt(id, 10);
			if (socials.indexOf(id) === -1) {
				socials.push(id);
				route.socials = socials;
			}
			this.setState({
				route: route,
				mainTweeter: id
			});
		}

	}

	resetTwitters() {

		let confirm = function() {
				let constants = this.props.app.config.constants,
					route = this.state.route,
					socials = this.state.route.socials,
					newSocials = [],
					socialButtonActive = this.state.socialButtonActive;

				for (let i = 0; i < socials.length; ++i) {
					let social = _.find(this.props.socials.list, function(social){
						return social.id == socials[i];
					}.bind(this));
					if (social && social.psID !== constants.POST_SVC_TWITTER) {
						newSocials.push(socials[i]);
					}
				}
				route.socials = newSocials;

				if (newSocials.length === 0) {
					socialButtonActive = false;
				}

				this.props.closeAllModals();

				this.setState({
					route: route,
					mainTweeter: 0,
					currentModal: null,
					socialButtonActive: socialButtonActive
				});

			}.bind(this),
			cancel = function() {
				this.props.closeAllModals(null);
			}.bind(this),
			modal = (
				<ConfirmModal
					cancelAction={cancel}
					confirmAction={confirm}
					modalCopy={"Deselecting your main Twitter will remove all retweeters too. Click on the main account in the tray to change it instead."}/>
			);

		this.props.addModal(modal);

	}

	selectInputType(type, subtype, crossPostType) {
		let constants = this.props.app.config.constants,
			inputType = 0,
			route = this.state.route,
			editedInput = this.state.editedInput;

		// oauth types start oauthing from tile click
		// except for instagram where there's a second selection screen
		if (type === 'wordpress' || type === 'instagram_chooser' ||
			type === 'feed_search_tile' || type === 'website_tile' || type === 'cross_post') {
			inputType = type;
		} else {
			inputType = (parseInt(subtype, 10)) ? parseInt(subtype, 10) : parseInt(type, 10);
		}

		// reset the route inputs if a user clicks on a tile to maintain
		// one input at a time for simple
		route.inputs = [];

		if (inputType === constants.INPUT_TYPE_FEED ||
				inputType === constants.INPUT_TYPE_TWITTER ||
				inputType === constants.INPUT_TYPE_INSTAGRAM ||
				inputType === 'wordpress' ||
				inputType === 'instagram_chooser' ||
				inputType === 'cross_post' ||
				inputType === 'website_tile' ||
				inputType === 'feed_search_tile') {
			editedInput = {};
			this.props.resetFeedValidation();
		}

		this.setState({
			editedInput,
			inputType,
			crossPostType,
			route
		}, () => {
			// call subtype click *after* setting state so createInput is called in the
			// right order and doesn't clobber editedInput
			if (subtype) {
				this.onSubtypeClick(null, subtype);
			}
		});

	}

	returnToTiles(e) {

		if (e) {
			e.preventDefault();
		}

		if (this.state.isFromAutomationsPage) {
			this.props.router.navigate("/share/automations");
		} else {
			this.setState({
				inputType: 0,
				crossPostType: 0
			});
		}

	}

	setSearchQuery(value) {
		this.setState({
			searchQuery: value
		});
	}

	showPostGroupModal() {
		this.setState({
			showPostGroupModal: (this.state.showPostGroupModal) ? false : true
		});
	}

	setNewSocial(newSocial) {

		this.setState({
			newSocial
		});

	}

	backButtonHandler(source) {
		let constants = this.props.app.config.constants,
			input = (this.state.route.inputs.length) ? this.state.route.inputs[0] : null,
			nextRoute = Utilities.deepClone(this.state.route),
			nextUrl = '',
			nextInputType = this.state.inputType,
			nextEditedInput = this.state.editedInput,
			nextCrossPostType = this.state.crossPostType;

		if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
			if (source === 'socials') {
				nextUrl = `${this.state.baseUrl}new/inputs`;
			}
		} else {
			if (source === 'socials') {
				// The post preview sits between the source and the destinations now, so
				// stepping back off destinations lands there and keeps the input intact.
				nextUrl = `${this.state.baseUrl}new/preview`;
			} else if (source === 'preview') {
				if (input && this.oauthConfigInputs.indexOf(input.type) !== -1) {
					nextUrl = `${this.state.baseUrl}new/configure`;
				} else {
					nextUrl = `${this.state.baseUrl}new/inputs`;
					nextRoute.inputs = [];
					nextEditedInput = null;
					nextRoute.socials = [];
				}
			} else if (source === "config") {
				if (input) {
					nextRoute.inputs = [];
					nextEditedInput = null;
					nextInputType = 0;
					switch (input.type) {
						case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
							nextUrl = `${this.state.baseUrl}new/inputs/instagram`;
							break;

						case constants.INPUT_TYPE_FACEBOOK_PAGE:
							nextUrl = `${this.state.baseUrl}new/inputs/facebook`;
							break;

						case constants.INPUT_TYPE_TIKTOK:
							nextUrl = `${this.state.baseUrl}new/inputs/tiktok`;
							break;

						default:
							break;
					}
				}
			} else if (source === "single-input" || source === "input") {
				if (nextInputType !== 0) {
					nextInputType = 0;
					nextRoute.inputs = [];
					nextEditedInput = null;
				}
				if (source === "single-input") {
					nextCrossPostType = 0;
				}
				nextUrl = `${this.state.baseUrl}new/inputs`;
			} else if (source === "review") {
				nextUrl = `${this.state.baseUrl}new/outputs`;
			}
		}

		if (!_.isEqual(nextRoute, this.state.route) ||
			this.state.inputType !== nextInputType ||
			!_.isEqual(nextEditedInput, this.state.editedInput) ||
			this.state.crossPostType !== nextCrossPostType) {
			this.setState({
				route: nextRoute,
				inputType: nextInputType,
				editedInput: nextEditedInput,
				crossPostType: nextCrossPostType
			}, () => {
				this.props.router.navigate(nextUrl);
			})
		} else {
			this.props.router.navigate(nextUrl);
		}
	}

	saveProgress(callback) {

		this.setState({
			creatingSocial: true
		}, () => {
			this.props.persistData("newRouteState", this.state);
			if (callback) {
				callback();
			}
		});

	}

	/*
		The destinations the review step draws, as OutputAccounts.

		Pre-filtered to the chosen ones with `selected: true`, rather than handed
		the whole list to filter itself: the step draws only the selection, and an
		account with hundreds of socials would map every one of them to throw
		nearly all away.

		No `disabledReason` and no retweet badge, unlike the destinations step's
		own mapping — nothing is selectable here, so a reason not to select
		something has nothing to attach to.
	*/
	reviewAccounts() {
		let constants = this.props.app.config.constants;

		return this.props.socials.list
			.filter((social) => { return this.state.route.socials.indexOf(social.id) !== -1; })
			.map((social) => {
				return outputAccountFromSocial(social, {
					constants: constants,
					selected: true,
					inactive: outputAccountInactive(social)
				});
			});

	}

	/* One of the review step's fields, routed through the form machinery the
	   legacy panel used, so the value lands where saveNewRoute reads it. */
	onReviewChange(path, value) {
		FormUtilityMixin.requestChange.call(this, {
			currentTarget: {
				dataset: {
					field: `editedInput.${path}`
				}
			},
			target: {
				value: value
			}
		});

	}

	/*
		A click on one of the wizard stepper's three nodes.

		The redesigned stepper draws the nodes but dropped their navigation, so this
		is NewRouteProgress.goToStep brought forward, with three differences:

		  - it navigates from this.state.baseUrl rather than a hardcoded
		    '/share/automate', which is what lets the flow work wherever else it is
		    mounted;
		  - Instagram is spelled correctly. The original tested
		    `INPUT_TYPE_INSTAGRAM_dBUSINESS` — undefined, so the test passed only for
		    an input with no type at all and an Instagram source was sent back to the
		    tiles instead of to its own panel. YouTube was missing from that list
		    outright; both come from this.oauthConfigInputs now;
		  - a forward jump to review needs a destination, which is what the
		    destinations step's own Next button already insists on. Without it the
		    stepper was a way around that button.

		Going backwards is never gated, and nothing is cleared on the way: the
		stepper is navigation, not an undo. backButtonHandler drops the input when it
		returns to the tiles; a step click keeps it, so the source the user picked is
		still selected when they arrive.
	*/
	goToStep(step) {
		let input = (this.state.route.inputs.length) ? this.state.route.inputs[0] : null;

		/*
			Both refusals are toasts rather than dead nodes. The redesign has no
			frame for a disabled step, and a control that goes quiet explains
			nothing — the render guards further down would bounce the user back to
			new/inputs with no word as to why.
		*/
		if (step > 1 && input === null) {
			makeToast("", "info", {
				title: "Input not complete",
				description: "Finish input before continuing"
			});

			return;
		}

		if (step > 2 && !this.state.route.socials.length) {
			makeToast("", "info", {
				title: "No destinations yet",
				description: "Choose where to post before continuing"
			});

			return;
		}

		/*
			Jumping forward skips the building screen, which is where the post
			preview is normally fetched. Start it here so stepping back onto the
			preview shows the real item instead of the sample card.
		*/
		if (step > 1 && !this.state.buildingInput) {
			this.setState({
				buildingInput: input,
				fetchingPreview: true
			}, () => {
				this.fetchPostPreview(input);
			});
		}

		if (step === 2) {
			this.props.router.navigate(`${this.state.baseUrl}new/outputs`);
		} else if (step === 3) {
			this.props.router.navigate(`${this.state.baseUrl}new/review`);
		} else if (input !== null && this.oauthConfigInputs.indexOf(input.type) !== -1) {
			this.props.router.navigate(`${this.state.baseUrl}new/configure`);
		} else {
			this.props.router.navigate(`${this.state.baseUrl}new/inputs`);
		}

	}

	render() {
		let Header = null,
			RouteName = null,
			MainContent = null,
			HeaderTabs = null,
			ConfigPanel = null,
			EditorButton = null,
			modal = null,
			canAddFeeds = true,
			tabClass = "",
			feedLink = "",
			errorNotice = null,
			searchErrors = null,
			constants = this.props.app.config.constants,
			currentPath = this.props.router.location.pathname,
			action = null,
			nextButtonLabel = "Continue",
			showOrientation = false,
			nextSectionLabel = '',
			feedType = null,
			topEditorButton = '',
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
			storeState = false,
			twitterInput = false,
			inputCount = 0,
			feedsValidated = false,
			progressBlock = null;

		if (this.props.app.configLoaded === false || this.props.app.loading.USER_FETCH) {
			return null;
		}

		// Be sure a user hasn't reached a step past the source with no inputs
		if ((currentPath.match("new/configure") && this.state.route.inputs.length === 0) ||
			(currentPath.match("new/building") && this.state.route.inputs.length === 0) ||
			(currentPath.match("new/preview") && this.state.route.inputs.length === 0) ||
			(currentPath.match("new/outputs") && this.state.route.inputs.length === 0) ||
			(currentPath.match("new/review") && this.state.route.inputs.length === 0)) {
			return null;
		}

		if (this.props.app.loading.SOCIAL_LIST) {
			return (
				<Content {...this.props} header={null} main={<Loading/>} modal={null}/>
			);
		}

		if (this.state.validatingFeed) {
			nextButtonLabel = (
				<div>
					<i className="fa fa-spinner fa-pulse"></i> Working
				</div>
			);
		}

		if (this.props.automatedRoutes.list.length === 0) {
			showOrientation = true;
		}

		if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
			// Controlled: a route restored after a social connect brings its own name, which an
			// input that only read its value on mount would never show.
			RouteName = <input type="text" className="dlvr-form text-input short" aria-label="Route name" value={this.state.route.name} onChange={this.updateRouteName}/>;
			Header = <CreateFeedHeader section="Your Routes" sectionLink="/share/automate" sectionParams={{}} action={RouteName}/>
		} else {
			// Header = <CreateFeedHeader section="Your Feeds" sectionLink="/share/automate" sectionParams={{}} action="New Feed"/>
			// if (this.state.route.inputs.length === 1) {
			// 	canAddFeeds = false;
			// }
		}

		if (onboarding !== null) {
			Header = null;
		}

		if (this.state.route.inputs.length >= 1) {
			inputCount = this.state.route.inputs.length;
			for (let i = 0; i < this.state.route.inputs.length; ++i) {
				if (this.state.route.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					twitterInput = true;
					break;
				}
			}
		}

		if (currentPath.match("new/inputs") ||
			(currentPath.match('new/configure') && this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED)) {

			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				action = this.transitionToSocialSelection;
				nextButtonLabel = (
					<span>Select outputs <i className="icon ion-ios-arrow-right"></i></span>
				);
				nextSectionLabel = '';

				let inputValidated = false;
				if (this.state.route.inputs.length) {
					inputValidated = true;
					for (let i = 0; i < this.state.route.inputs.length; ++i) {
						if (!this.state.route.inputs[i].inputValid) {
							inputValidated = false;
							break;
						}
					}
				}

				EditorButton =  (
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={inputValidated}
						saveLabel={nextButtonLabel}
						stepLabel={nextSectionLabel}
						saveAction={action} />
				);

			} else {
				// The manual "Next" for a feed that validated on an earlier visit to this
				// step. It goes through building like the automatic hand-off does, so
				// this path can't reach destinations with no preview fetched.
				action = () => {
					this.transitionToBuilding(this.state.route.inputs[0]);
				};
				nextButtonLabel = "Next"
				nextSectionLabel = '';

				if (this.state.route.inputs.length) {
					feedsValidated = true;
					for (let i = 0; i < this.state.route.inputs.length; ++i) {
						// only feed types need to check for validation
						let noValidationTypes = [
							constants.INPUT_TYPE_TWITTER,
							constants.INPUT_TYPE_FACEBOOK_PAGE,
							constants.INPUT_TYPE_INSTAGRAM,
							constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
							constants.INPUT_TYPE_TIKTOK,
							constants.INPUT_TYPE_YOUTUBE,
						];
						if (noValidationTypes.indexOf(parseInt(this.state.route.inputs[i].type, 10)) === -1) {
							if (this.state.route.inputs[i].feedValid === undefined ||
								!this.state.route.inputs[i].feedValid) {
								feedsValidated = false;
								break;
							}
						}
					}
				}

				EditorButton = (
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={feedsValidated}
						saveLabel={nextButtonLabel}
						stepLabel={nextSectionLabel}
						backAction={this.returnToTiles}
						saveAction={action} />
				);
			}

			if (this.state !== null) {
				searchErrors = this.state.searchErrors;
			}

			if (this.state.validationErrors !== null) {
				searchErrors = this.state.validationErrors;
				errorNotice = (
					<div className="detail-status error">
						{"We can't get the feed you wanted. Check the errors for details."}
					</div>
				);
			}

			/*
				The "source" step. AutomationShell replaces NewRouteProgress +
				CaretBorder + EditorButtons: it draws the same three-step progress
				and the wizard's own Back action.

				ChooseFeedType keeps every side effect of a tile click — the
				entitlement gates, the analytics events, the OAuth handoff and the
				ReuseSocialInputModal a social source needs when credentials
				already exist — and only swaps its artwork for the new step. See
				its `tile` prop.
			*/
			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE &&
				this.state.externalFeedUrl === '' &&
				(this.state.inputType === 0 ||
				 this.state.inputType === 'instagram_chooser' ||
				 this.state.inputType === 'cross_post')) {
				MainContent = (
					<div className="tw-root">
						<AutomationShell
							step="source"
							backLabel={(this.state.crossPostType !== 0) ? "Back" : undefined}
							onBack={() => {
								// a tile opens its network's step directly, so Back returns to the
								// tiles, as the find step's does
								if (this.state.isFromAutomationsPage) {
									this.returnToTiles();
								} else {
									this.backButtonHandler('single-input');
								}
							}}
							onStepSelect={this.goToStep}>
							<ChooseFeedType
								{...this.props}
								tile={true}
								inputType={this.state.inputType}
								crossPostType={this.state.crossPostType}
								inputSelectCallback={this.selectInputType}
								returnToTiles={this.returnToTiles}
								setSearchQuery={this.setSearchQuery}
								storeRouteState={this.storeRouteState}
								reuseInput={this.createInput} />
						</AutomationShell>
					</div>
				);
			} else if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE && this.guidedInputs.indexOf(this.state.inputType) !== -1) {
				let inputPanel = null;

				/*
					The "configure" step: the inputs that need more from the user
					before they'll work — a username, a store address, a channel.

					Twitter keeps the legacy panel. It has no design frame, and no
					source tile reaches it: nothing in ChooseFeedType offers
					Twitter, so this branch is only live for an input that arrived
					some other way.
				*/
				if (this.state.inputType === constants.INPUT_TYPE_TWITTER) {
					inputPanel = (
						<TwitterInputConfigPanel
                            {...this.props}
                            input={this.state.editedInput}
                            changeHandler={FormUtilityMixin.requestChange.bind(this)}
                            statePath={"editedInput"}
							showBehavior={false} />
					);
				} else {
					inputPanel = (
						<CreateSubtypePanel
							{...this.props}
							tile={true}
							input={this.state.editedInput}
							subtype={this.state.inputType}
							validateInput={this.validateInputConfiguration}
							changeHandler={FormUtilityMixin.requestChange.bind(this)}
							statePath="editedInput" />
					)
				}

				MainContent = (
					<div className="tw-root">
						<AutomationShell
							step="configure"
							subtitle={CreateSubtypePanel.subtitleFor(this.state.inputType, constants)}
							backLabel="Back"
							primaryLabel="Next"
							onBack={() => {
								this.backButtonHandler('input');
							}}
							onPrimary={this.validateInputConfiguration}
							onStepSelect={this.goToStep}>
							{inputPanel}
						</AutomationShell>
					</div>
				);
			} else {
				// let's make sure COMPLEX gets the right icon in FeedEditorTabs
				let inputType = this.state.inputType;
				if (inputType === 0 && this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
					inputType = constants.INPUT_TYPE_FEED;
				} else if (inputType === 'feed_search_tile' || inputType === 'website_tile') {
					inputType = constants.INPUT_TYPE_FEED;
				}

				if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
					progressBlock = (
						<FeedEditorTabs
							{...this.props}
							inputType={inputType}
							currentSection="feed"
							showSocial={true}
							showOrientation={false}/>
					);
				} else {
					progressBlock = (
						<div>
							<NewRouteProgress
								{...this.props}
								inputType={inputType}
								currentSection={1}
								newRoute={this.state.route}/>
							<CaretBorder/>
						</div>
					);
				}

				/*
					The "find" step. SIMPLE only: ADVANCED keeps FeedEditorTabs and the
					legacy search, since none of this flow's redesign applies to it.

					A validated feed goes to the "building" step from here (see
					componentDidUpdate), not straight to outputs. The design's
					"feed-preview" frame is not a step in this flow at all — it is the
					standalone feedPreview.php page, reached from a feed's own link.
				*/
				if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
					MainContent = (
						<div className="tw-root">
							<AutomationShell
								step="find"
								backLabel="Back"
								primaryLabel={nextButtonLabel}
								primaryDisabled={!feedsValidated}
								onBack={this.returnToTiles}
								onPrimary={action}
								onStepSelect={this.goToStep}>
								<CreateFeed
									{...this.props}
									onboarding={onboarding}
									onFeedSelect={this.createInput}
									onFeedRemoval={this.feedRemoval}
									initialFeeds={this.state.route.inputs}
									canAddFeeds={canAddFeeds}
									onAdvancedFeedConfigure={this.onAdvancedFeedConfigure}
									onSocialClick={this.storeRouteState}
									onSubtypeClick={this.onSubtypeClick}
									recordPath={this.props.recordPath}
									searchErrors={searchErrors}
									removeInvalidFeeds={this.removeInvalidFeeds}
									externalFeedUrl={this.state.externalFeedUrl}
									twitterInput={twitterInput}
									inputCount={inputCount}
									returnToTiles={this.returnToTiles}
									inputType={this.state.inputType}
									isValidating={this.state.validatingFeed}
									searchQuery={this.state.searchQuery}
									tile={true} />
							</AutomationShell>
						</div>
					);
				} else {
					MainContent = (
						<div>
							{progressBlock}
							<CreateFeed
								{...this.props}
								onboarding={onboarding}
								onFeedSelect={this.createInput}
								onFeedRemoval={this.feedRemoval}
								initialFeeds={this.state.route.inputs}
								canAddFeeds={canAddFeeds}
								onAdvancedFeedConfigure={this.onAdvancedFeedConfigure}
								onSocialClick={this.storeRouteState}
								onSubtypeClick={this.onSubtypeClick}
								recordPath={this.props.recordPath}
								searchErrors={searchErrors}
								removeInvalidFeeds={this.removeInvalidFeeds}
								externalFeedUrl={this.state.externalFeedUrl}
								twitterInput={twitterInput}
								inputCount={inputCount}
								returnToTiles={this.returnToTiles}
								inputType={this.state.inputType}
								isValidating={this.state.validatingFeed}
								searchQuery={this.state.searchQuery} />
							{EditorButton}
						</div>
					);
				}
			}


			if (currentPath.match('new/configure') && this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				modal = (
					<InputModal
						{...this.props}
						input={this.state.editedInput}
						errors={this.state.validationErrors}
						onModalClose={this.onModalClose}
						onSave={this.modalSave}
						baseUrl={this.state.baseUrl} />
				);
			}
		} else if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE && currentPath.match("new/configure")) {
			tabClass = "editor-title-tab";

			if (currentPath.match("new/configure/input")) {
				tabClass = "editor-title-tab tab-active";
				feedLink = "new-route-configure";
			}

			// if (onboarding === null) {
			// 	Header = (
			// 		<CreateFeedHeader
			// 			{...this.props}
			// 			sectionLink="/share/automate"
			// 			section="Your Feeds"
			// 			action="New Feed"
			// 			tabs={HeaderTabs} />
			// 	);
			// }

			/*
				The "configure" step for a source connected over OAuth.

				NOT vestigial, despite an earlier note here saying so. It is dead for
				FEED inputs only — createInput sends those back to new/inputs — but
				Instagram, Facebook, TikTok and YouTube are none of them in
				guidedInputs, so createInput routes all four here and
				CreateFeedConfigure dispatches to their panels. Three of those are
				featured source tiles, so this is a common path, not a dead one.

				`tile` reaches each panel through CreateFeedConfigure's prop spread.
				YouTube reads it and renders the new ConfigureStep; the others ignore
				it and keep their own fields inside the new shell until they have
				design frames of their own.
			*/

			ConfigPanel = (
				<CreateFeedConfigure
					{...this.props}
					tile={true}
					input={this.state.editedInput}
					errors={this.state.validationErrors}
					changeHandler={FormUtilityMixin.requestChange.bind(this)}
					textRuleHandler={this.requestTextRuleChange}
					scheduleHandler={this.requestScheduleChange}
					statePath="editedInput" />
			);

			feedType = (this.state.editedInput.subtype !== undefined) ? this.state.editedInput.subtype : this.state.editedInput.type;

			MainContent = (
				<div className="tw-root">
					<AutomationShell
						step="configure"
						subtitle={configureSubtitle(this.state.editedInput, constants)}
						backLabel="Back"
						primaryLabel="Next"
						onBack={() => {
							this.backButtonHandler('config')
						}}
						onPrimary={this.validateInputConfiguration}
						onStepSelect={this.goToStep}>
						{errorNotice}
						{ConfigPanel}
					</AutomationShell>
				</div>
			);
		} else if (currentPath.match("new/building")) {
			/*
				The "building" step. No wizard actions and no onStepSelect: it advances
				itself, so a Back button — or a live stepper node — on a screen that
				leaves in two seconds would only ever be a mis-click. The browser's own
				Back still works, landing on the source step, same as the post
				preview's Back.
			*/
			let buildingInput = this.state.buildingInput || this.state.route.inputs[0],
				sourceName = (buildingInput && buildingInput.name) ? buildingInput.name : 'your source';

			MainContent = (
				<div className="tw-root">
					<AutomationShell step="building">
						<BuildingProgress
							heading="Building your automation"
							labels={[
								`Connected to ${sourceName}`,
								'Reading recent items',
								'Calculating update frequency',
								'Preparing your preview'
							]}
							onComplete={this.transitionToPostPreview}/>
					</AutomationShell>
				</div>
			);

		} else if (currentPath.match("new/preview")) {
			/*
				The "post-preview" step, between the source and the destinations.

				It does NOT depend on the destinations, which is why it can sit before
				them — nor on the accounts the user has connected. Everyone sees the
				same four networks: the card is about the source, and showing it before
				anything is connected is the point.
			*/
			let previewInput = this.state.buildingInput || this.state.route.inputs[0],
				activeNetwork = (this.state.previewNetwork && POST_PREVIEW_NETWORKS.indexOf(this.state.previewNetwork) !== -1)
					? this.state.previewNetwork
					: POST_PREVIEW_NETWORKS[0];

			MainContent = (
				<div className="tw-root">
					<AutomationShell
						step="post-preview"
						backLabel="Back"
						primaryLabel="Next"
						onBack={() => {
							this.backButtonHandler('preview');
						}}
						onPrimary={this.transitionToSocialSelection}
						onStepSelect={this.goToStep}>
						<PostPreviewStep
							source={connectedSourceFromInput(this.state.previewPayload, previewInput, constants)}
							base={assetBase(this.props.app.config)}
							networks={POST_PREVIEW_NETWORKS}
							activeNetwork={activeNetwork}
							post={postPreviewFromPayload(this.state.previewPayload, previewInput, constants)}
							loading={this.state.fetchingPreview}
							error={this.state.previewError}
							onNetworkChange={(network) => {
								this.setState({
									previewNetwork: network
								}, () => {
									this.recordPreviewEvent('Automation Post Preview - Network Change', {
										network: network
									});
								});
							}}/>
					</AutomationShell>
				</div>
			);

		} else if (currentPath.match("new/outputs")) {

			feedType = (this.state.route.inputs[0].subtype) ? this.state.route.inputs[0].subtype : this.state.route.inputs[0].type;

			let twitterCount = 0;
			for (let key in this.props.socials.list) {
				let test = _.find(this.props.socials.list, function(social) {
					return this.props.socials.list[key] == social.id;
				}.bind(this));
				if (test !== undefined) {
					if (test.psID == constants.POST_SVC_TWITTER) {
						++twitterCount;
					}
				}
			}

			// if ((this.props.socials.list.length > 14 && (this.props.socials.filter === undefined || (this.props.socials.filter !== undefined && !this.props.socials.filter.value))) ||
			// 	(this.props.socials.filter !== undefined && this.props.socials.filter.value && this.props.socials.filteredList.length > 14)) {
			// 	let topButtonClass = (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) ? "social-list-top advanced" : "social-list-top",
			// 		buttonLabel = this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCES ? "Start posting" : "Next Step";

			// 	topEditorButton = <EditorButtons
			// 						{...this.props}
			// 						showCancel={false}
			// 						saveActive={this.state.socialButtonActive}
			// 						saveLabel={buttonLabel}
			// 						saveAction={this.saveNewRoute}
			// 						extraComponentClasses={topButtonClass} />;
			// }

			let creatingSocial = this.state.creatingSocial || this.props.app.loading.SOCIAL_LIST,
				buttonLabel =  this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED ? "Start posting" : "Next",
				editorButtons = (
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={this.state.route.socials.length ? true : false}
						saveLabel={buttonLabel}
						saveAction={() => {
							this.transitionToReview();
						}}
						backAction={() => {
							this.backButtonHandler('socials');
						}}  />
				);

			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				progressBlock = (
					<FeedEditorTabs
						{...this.props}
						inputType={feedType}
						feedLabel={this.state.route.inputs[0].name}
						showSocial={true}
						showOrientation={showOrientation}
						currentSection="social" />
				);
				editorButtons = (
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={this.state.route.socials.length ? true : false}
						saveLabel={buttonLabel}
						saveAction={() => {
							this.saveNewRoute();
						}}
						backAction={() => {
							this.backButtonHandler('socials');
						}}  />
				)
			}

			if (this.state.showPostGroupModal) {
				let cancelAction = () => {
					this.setState({
						showPostGroupModal: false
					});
				};

				modal = (
					<MinimalModal
						content={
							<PostingGroups
								{...this.props}
								confirmAction={(socials) => {
									for (let i = 0; i < socials.length; ++i) {
										this.onSocialClick(null, parseInt(socials[i]));
									}
									this.setState({
										showPostGroupModal: false
									});
								}}
								cancelAction={cancelAction}/>
						}
						cancelAction={cancelAction}/>
				);
			}



			let outputPanel = (
				<CreateFeedSocial
					{...this.props}
					route={this.state.route}
					displayHeader={false}
					onboarding={onboarding}
					outputs={[]}
					socialSearch={this.filterSocialsByName}
					socialFilter={this.filterSocialsByType}
					socialClickHandler={this.onSocialClick}
					selectedSocials={this.state.route.socials}
					connectHandler={this.onConnectSocial}
					onReactivate={this.onReactivate}
					reconnectHandler={this.beforeReconnect}
					creatingSocial={creatingSocial}
					mainTweeter={this.state.mainTweeter}
					setMainTweeter={this.setMainTweeter}
					resetTwitters={this.resetTwitters}
					topButton={topEditorButton}
					showPostGroupModal={this.showPostGroupModal}
					routeCreateError={this.state.routeCreateError}
					tile={this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE}/>
			);

			/*
				The "destinations" step. AutomationShell replaces NewRouteProgress
				+ CaretBorder + EditorButtons, and CreateFeedSocial's `tile` prop
				swaps the social list for the design's tile grid. Everything the
				legacy list owns stays with it — see SocialSelection.renderTileStep.

				The "post-preview" step is now BEFORE this one, not between it and
				review: it describes the source rather than the chosen outputs, so it
				has nothing to wait for here.
			*/
			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
				MainContent = (
					<div className="tw-root">
						<AutomationShell
							step="destinations"
							backLabel="Back"
							primaryLabel={buttonLabel}
							primaryDisabled={!this.state.route.socials.length}
							onBack={() => {
								this.backButtonHandler('socials');
							}}
							onPrimary={this.transitionToReview}
							onStepSelect={this.goToStep}>
							{outputPanel}
						</AutomationShell>
					</div>
				);
			} else {
				MainContent = (
					<div className="create-feed-social-wrapper">
						{progressBlock}
						{outputPanel}
						{editorButtons}
					</div>
				);
			}

		} else if (currentPath.match("new/review")) {
			/*
				The "review" step, and the last of the flow to move onto the new
				design. AutomationShell replaces NewRouteProgress + CaretBorder +
				EditorButtons; ReviewStep replaces ReviewPanel.

				Two things ReviewPanel did are deliberately gone:

				  - the input preview and its lightbox. The post preview is its own
				    step now, before destinations, and it shows the same item with
				    per-network framing. Keeping a second copy here would be the
				    only place in the flow rendering `embedHtml` through
				    dangerouslySetInnerHTML.
				  - the ErrorModule on the name field. It listened for
				    INPUT_VALIDATE, and nothing validates the input at this point —
				    saveNewRoute says as much where it forces inputValid. A name
				    the backend rejects surfaces as a ROUTE_CREATE error, which
				    componentDidUpdate already carries back to the outputs step.
			*/
			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
				let reviewInput = this.state.editedInput || {},
					firstPull = firstPullChoices(constants),
					postWhen = postWhenChoices(constants),
					firstPullValue = behaviorValue(reviewInput.firstPullFlag, constants.FIRSTPULL_SINGLE),
					postWhenValue = behaviorValue(reviewInput.postFlag, constants.POST_NOW);

				MainContent = (
					<div className="tw-root">
						<AutomationShell
							step="review"
							backLabel="Back"
							primaryLabel="Start Posting"
							primaryDisabled={this.state.isCreatingRoute}
							onBack={() => {
								this.backButtonHandler('review');
							}}
							onPrimary={this.saveNewRoute}
							onStepSelect={this.goToStep}>
							<ReviewStep
								base={assetBase(this.props.app.config)}
								source={connectedSourceFromInput(this.state.previewPayload, reviewInput, constants)}
								accounts={this.reviewAccounts()}
								automationName={reviewInput.name || ''}
								postFirstOptions={firstPull}
								postFirst={firstPullValue}
								postFirstHelp={choiceHelp(firstPull, firstPullValue)}
								postWhenOptions={postWhen}
								postWhen={postWhenValue}
								postWhenHelp={choiceHelp(postWhen, postWhenValue)}
								reassurance="You can pause or edit this anytime."
								onNameChange={(name) => {
									this.onReviewChange(REVIEW_BEHAVIOR_PATHS.name, name);
								}}
								onPostFirstChange={(value) => {
									this.onReviewChange(REVIEW_BEHAVIOR_PATHS.firstPull, value);
								}}
								onPostWhenChange={(value) => {
									this.onReviewChange(REVIEW_BEHAVIOR_PATHS.postWhen, value);
								}}/>
						</AutomationShell>
					</div>
				);
			} else {
				MainContent = (
					<div>
						<NewRouteProgress
							{...this.props}
							inputType={feedType}
							feedLabel={this.state.route.inputs[0].name}
							currentSection={3}
							newRoute={this.state.route}/>
						<CaretBorder/>
						<ReviewPanel
							{...this.props}
							input={this.state.editedInput}
							onboarding={onboarding}
							changeHandler={FormUtilityMixin.requestChange.bind(this)}
							statePath="editedInput"/>
						<EditorButtons
							{...this.props}
							showCancel={false}
							saveActive={true}
							saveLabel={"Start Posting"}
							saveAction={this.saveNewRoute}
							backAction={() => {
								this.backButtonHandler('review');
							}}  />
					</div>
				);
			}
		}

		return (
			<Content {...this.props} header={Header} main={MainContent} modal={modal}/>
		);
	}
};

RouteNew.reportedErrors = [];
RouteNew.displayName = "RouteNew";

const enhance = compose(
	ComponentWithContext,
	FeedProvider,
	PostGroupProvider
);

export default enhance(RouteNew);
